module.exports = __webpack_public_path__ + "img/zoom-minus.b003f66b.svg";